module.exports = __webpack_public_path__ + "img/1032.0f769ff0.png";